import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { pismenaCislaRegExp } from 'enums/regExp';

export const pismenaCislaValidation = () => [
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || pismenaCislaRegExp.test(value)) return Promise.resolve();
            if (value && !pismenaCislaRegExp.test(value))
                return Promise.reject(<TranslateText>NEVALIDNI_NUM_LAT</TranslateText>);
            return Promise.resolve();
        }
    })
];

export default pismenaCislaValidation;
